import { createAction } from 'redux-actions';

export const showConfirmDeleteReportTemplate = createAction(
  'SHOW_CONFIRM_DELETE_REPORT_TEMPLATE'
);

export const hideConfirmDeleteReportTemplate = createAction(
  'HIDE_CONFIRM_DELETE_REPORT_TEMPLATE'
);
